// extracted by mini-css-extract-plugin
export default {"overlay":"Jw-z","bodyOpen":"Kw-z","content":"Lw-z","header":"Mw-z","close":"Nw-z","closeNoHeading":"Ow-z"};